import {IRestService} from "./IRestService";

export interface VehicleModel {
    baseVehicleId: number;
    modelName: string;
}

export interface Fitment {
    id: string;
    productType: string;
    productId: string;
    baseVehicleId: number;
    year: number;
    makeName: string;
    modelName: string;
    notes?: string;
}

export interface FitmentVehicleInput {
    baseVehicleId: number;
    year: number;
    makeName: string;
    modelName: string;
    notes?: string;
}

/**
 * Wraps the JXB.API vehicle (SEMA/VCdb) lookups and product-to-vehicle fitment endpoints.
 */
export class VehicleService {

    public constructor(private readonly restService: IRestService) {
    }

    public async getYears(): Promise<number[]> {
        return this.restService.get(`vehicles/years`);
    }

    public async getMakes(year?: number): Promise<{ makeName: string }[]> {
        const q = year ? `?year=${year}` : ``;
        return this.restService.get(`vehicles/makes${q}`);
    }

    public async getModels(year: number, make: string): Promise<VehicleModel[]> {
        return this.restService.get(`vehicles/models?year=${year}&make=${encodeURIComponent(make)}`);
    }

    public async getFitments(productType: string, productId: string): Promise<Fitment[]> {
        return this.restService.get(`fitments?productType=${encodeURIComponent(productType)}&productId=${productId}`);
    }

    public async addFitments(productType: string, productId: string, vehicles: FitmentVehicleInput[]): Promise<Fitment[]> {
        return this.restService.post(`fitments`, {productType, productId, vehicles});
    }

    public async removeFitment(id: string): Promise<void> {
        return this.restService.delete(`fitments/${id}`);
    }

    public async bulkAddFitments(products: { productType: string, productId: string }[], vehicles: FitmentVehicleInput[]): Promise<{ added: number }> {
        return this.restService.post(`fitments/bulk`, {products, vehicles});
    }
}
